import { subscribe } from '@wh/message-bus';
import { isNative, isUserAgent } from '../../utils';
import { ANDROID_SPAIN_SPORTSBOOK_NATIVE_APP_USER_AGENT } from '../../constants';

export const myAccountNativeDeepLinksFromMessagebusPlugin = {
  postBootstrap({ params }) {
    if (!isNative() || isUserAgent(ANDROID_SPAIN_SPORTSBOOK_NATIVE_APP_USER_AGENT)) {
      return;
    }

    subscribe({
      topic: 'wh.myAccount.command.dropdown.open',
      callback: ({ data }) => {
        const standaloneUrl = data && params.mapping[data.path];
        if (!standaloneUrl) {
          return;
        }
        window.location.href = `whsbkh://?action=openURLWithLogin&url=${encodeURIComponent(standaloneUrl)}`;
      },
    });
  },
};
